/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { createAsyncLocalSuperstore } from 'superstore';
import { wipeSuperstore as wipeIndexedDBSuperstore } from 'marketing-platform-lib/utils/superstore';

export const SUPERSTORE_NAMESPACE = 'framework-listing-lib';

type LocalStore = {
  get(key: string): Promise<string | null>;
  set(key: string, value: string): Promise<string | null>;
  has(key: string): Promise<boolean>;
  delete(key: string): Promise<string | null>;
  clear(): Promise<void>;
};

let localStoreInstance: LocalStore;

export function getLocalStore() {
  if (!localStoreInstance) {
    localStoreInstance = createAsyncLocalSuperstore({
      namespace: SUPERSTORE_NAMESPACE,
    });
  }
  return localStoreInstance;
}

export function wipeSuperstore() {
  return Promise.all([
    wipeIndexedDBSuperstore(SUPERSTORE_NAMESPACE),
    getLocalStore().clear(),
  ]);
}
